import apiService from './apiService';

/**
 * Service pour les produits normaux (vente en gros)
 */
class NormalProductService {
  /**
   * Récupère la liste des produits normaux avec filtres
   * @param {Object} params - Paramètres de recherche (search, paginate, orderby, order, product_id)
   */
  async getNormalProducts(params = {}) {
    const response = await apiService.get('/normal-product-variants', params);
    return response.data;
  }

  /**
   * Récupère un produit normal spécifique
   * @param {string} id - ID du produit normal
   */
  async getNormalProduct(id) {
    const response = await apiService.get(`/normal-product-variants/${id}`);
    return response.data;
  }

  /**
   * Crée un nouveau produit normal
   * @param {Object} productData - Données du produit normal
   */
  async createNormalProduct(productData) {
    const response = await apiService.post('/normal-product-variants', productData);
    return response.data;
  }

  /**
   * Met à jour un produit normal
   * @param {string} id - ID du produit normal
   * @param {Object} productData - Nouvelles données
   */
  async updateNormalProduct(id, productData) {
    const response = await apiService.put(`/normal-product-variants/${id}`, productData);
    return response.data;
  }

  /**
   * Supprime un produit normal
   * @param {string} id - ID du produit normal
   */
  async deleteNormalProduct(id) {
    return apiService.delete(`/normal-product-variants/${id}`);
  }
}

const normalProductServiceInstance = new NormalProductService();
export default normalProductServiceInstance;
